import { QlfConfirmationDialog, useQlfTranslation } from '@qualifio/ui-commons';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePublishTemplate } from '../../hooks/use-templates';

interface PublishTemplateVersionDialogProps {
  open: boolean;
  templateId: string;
  templateName?: string;
  onClose: () => void;
}

export function PublishTemplateVersionDialog({
  open,
  templateId,
  templateName,
  onClose,
}: PublishTemplateVersionDialogProps) {
  const { t } = useTranslation();
  const { t: htmlT } = useQlfTranslation('translation');
  const { mutateAsync: publishTemplate } = usePublishTemplate();

  const handleConfirm = useCallback(async () => {
    await publishTemplate(templateId);
    onClose();
  }, [publishTemplate, templateId, onClose]);

  const versionReference = useMemo(() => {
    if (templateName) {
      return t('editor.template.version.reference.withNameCapitalized', { name: templateName });
    }
    return t('editor.template.version.reference.thisVersion');
  }, [templateName, t]);

  return (
    <QlfConfirmationDialog
      title={t('editor.template.version.publish.dialog.title')}
      content={htmlT('editor.template.version.publish.dialog.message', { versionReference })}
      confirmButtonText={t('editor.template.version.publish.dialog.confirm')}
      cancelButtonText={t('generic.actions.cancel')}
      onConfirm={handleConfirm}
      onClose={onClose}
      color="warning"
      confirmButtonColor="secondary"
      open={open}
    />
  );
}
